import { Text } from "@chakra-ui/react";
import { StatesMachine } from "components/pipeline-components/classes/state-machine/state-machine";
import { DiagnosticPanel } from "./DiagnosticPanel";

export function HigienizacaoOfflineEditor({
  selectedStateId,
  pipelineData,
  diagnosticUpdatePipelineData
}: {
  selectedStateId?: number;
  pipelineData?: StatesMachine;
  diagnosticUpdatePipelineData?: (
    updater: (draft: StatesMachine) => StatesMachine | void
  ) => void;
}) {
  return (
    <>
      <Text color="#90a1b9" fontWeight="600" fontSize="sm">
        Este bloco consulta os CPFs (ou números do benefício) presentes no
        arquivo e enriquece a base com informações dos contratos localizados,
        como banco, número do contrato, valor da parcela, valor do contrato e
        outros dados relacionados.
      </Text>
      {selectedStateId != null &&
        pipelineData &&
        diagnosticUpdatePipelineData && (
          <DiagnosticPanel
            selectedStateId={selectedStateId}
            pipelineData={pipelineData}
            operation="HIGIENIZACAO_OFFLINE"
            updatePipelineData={diagnosticUpdatePipelineData}
          />
        )}
    </>
  );
}
